import { reactive } from 'vue';

export const inboxStates = reactive({});
export const inboxWids = reactive({});
export const inboxMessageProcessing = reactive({});
export const inboxStateSnapshots = reactive({});

const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object, key);

// Socket transitions and direct API checks must update the same snapshot so
// every QuePasa status surface renders one consistent state per inbox.
export const applyInboxStatePayload = (payload = {}) => {
  const inboxId = payload.inbox_id;
  if (!inboxId) return null;

  const previous = inboxStateSnapshots[inboxId] || {};
  const snapshot = { ...previous };
  const state = payload.state || payload.current_state;

  if (state) {
    snapshot.state = state;
    inboxStates[inboxId] = state;
  }
  if (hasOwn(payload, 'wid')) {
    snapshot.wid = payload.wid || '';
    inboxWids[inboxId] = snapshot.wid;
  }
  if (hasOwn(payload, 'meta_coexistence')) {
    snapshot.metaCoexistence = payload.meta_coexistence;
  }
  if (hasOwn(payload, 'message_processing_enabled')) {
    snapshot.messageProcessingEnabled = payload.message_processing_enabled;
    inboxMessageProcessing[inboxId] = payload.message_processing_enabled;
  }

  const version = payload.health?.version || payload.version;
  const checkedAt =
    payload.health?.timestamp || payload.checked_at || payload.changed_at;
  if (version) snapshot.version = version;
  if (checkedAt) snapshot.checkedAt = checkedAt;

  inboxStateSnapshots[inboxId] = snapshot;
  return snapshot;
};
